import VectorModule from './VectorModule';
import { Feature } from 'ol';
import { LineString } from 'ol/geom';
import { baseProjection, targetProjection } from '../../projection';

class PipeLineModule extends VectorModule {
  //
  // 단일 피쳐 생성 (속성 정보 추가)
  public createPipeLineFeature(data: any, layerId: string) {
    const points = [
      [data.stCoordinate.y, data.stCoordinate.x],
      [data.endCoordinate.y, data.endCoordinate.x],
    ];

    const ymdTimestamp = new Date(data.ymd).getTime();
    const now = Date.now();

    // 현재 시점에서 5년/10년 지났는지 여부
    const fiveYearsLater = now >= ymdTimestamp + 5 * 365 * 24 * 60 * 60 * 1000;
    const tenYearsLater = now >= ymdTimestamp + 10 * 365 * 24 * 60 * 60 * 1000;

    const lineStringFeature = new Feature({
      id: 'pipeLine',
      geometry: new LineString(points),
      properties: {
        ...data,
        layerId,
        tenYearsLater,
        fiveYearsLater,
      },
    });
    lineStringFeature.getGeometry()?.transform(targetProjection, baseProjection);
    return lineStringFeature;
  }

  // 피쳐 배열 리턴
  public createPipeLineFeatures(datas: any[], layerId: string) {
    return datas?.map((data) => {
      return this.createPipeLineFeature(data, layerId);
    });
  }
}

export default PipeLineModule;
